import { createGlobalState } from 'react-hooks-global-state';

export const { useGlobalState } = createGlobalState({
  data: {
    painted: true,
    painted_temp: true,
    mesh_options: 'tt',
    mesh_options_temp: 'tt',
    all_meshes_loaded: false,
    redisplay: false,
    initdisplay: false,
    loading: true,
    load_started: false,
    search: '',
    searchVisible: false,
    searchDone: true,
    expanded: false,
    x: 0,
    y: 0,
    z: 0,
    r: 0.5,
    label: 'Search result label.',
    description: ['Search results description.']
  },
});
